import type { HeaderConfig } from '../../header.types.ts';

const headerConfig: HeaderConfig = {
  showsInfoBanner: true,
  showsSearch: true,
};

export { headerConfig };
